/* eslint-disable @typescript-eslint/no-explicit-any -- richiede ulteriori verifiche */

export const InjectDecorator = (props: React.PropsWithChildren<{ node: any }>) => {
  return <div data-welfare-componentid={props.node?.attribs?.['data-welfare-componentid']}>{props.children}</div>
}
